import { UserStore,UserProfile } from 'journey-store';
import { inject, Injectable } from '@angular/core';
import { User } from 'app/core/user/user.types';
import { Observable} from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';


@Injectable({ providedIn: 'root' })
export class FuseUserService {
    private userStore = inject(UserStore);
    private userProfile = this.userStore.profile;
    private userProfile$:any;

    constructor(){
        this.userProfile$ = toObservable(this.userProfile);
    }

    // private _httpClient = inject(HttpClient);
    // private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    // set user(value: User) {
    //     // Store the value
    //     this._user.next(value);
    // }

    get user$(): Observable<User> {
        return this.userProfile$;
        // return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): UserProfile {
        return this.userProfile();
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any>{
        console.log('UPDATE USER called');
        return this.userProfile$;
    }
}

